import {SettingsParamType} from '@wix/tpa-settings';

export type ISettingsParams<T> = Record<keyof T, SettingsParamType>;

export function getFreeTextKeys<T>(settingsParams: T): (keyof T)[] {
  return Object.entries(settingsParams)
    .reduce((acc, [k, v]) => [...acc, v.type === SettingsParamType.String ? k : undefined], [])
    .filter(Boolean) as (keyof T)[];
}
